import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  footer: {
    fontSize: "12px",
    width: "100%",
    //
    //
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
    [theme.breakpoints.down("lg")]: {
      width: "100%",
    },
    [theme.breakpoints.up("xl")]: {
      width: "100%",
    },
    color: theme.palette.text.primary,
    fontWeight: 500,
    lineHeight: "18px",
  },
  box: {
    display: "flex",
    marginTop: 30,
  },
  footerText: {
    fontSize: "12px",
    fontWeight: 500,
  },
  link: {
    color: "#0d6efd",
    fontWeight: 400,
    cursor: "pointer",
    fontSize: "12px",
  },
}));
export default useStyles;
